import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber1 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm.994 11.902h-1.47V5.547l-1.765.436V4.677l3.236-.766v7.99z" />
    </g>
  );
};

export default withIcon(IconNumber1);
